"use client";

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const RouteGuard = ({ children, protectedRoute = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (protectedRoute && id) {
      const paymentSubmitted = sessionStorage.getItem(
        `payment_submitted_${id}`
      );
      if (paymentSubmitted === "true") {
        // Redirect to expired page if trying to access protected route after submission
        navigate(`/payment-expired`, { replace: true });
      }
    }
  }, [protectedRoute, id, navigate]);

  return <>{children}</>;
};

export default RouteGuard;
